import { useCurrentAccount } from "PFCore/hooks/queries/account/use_current_account";
import { ApiRoute, UiRoute } from "PFCore/utilities/routes";
import { useEffect } from "react";
import { useSearchParams } from "react-router";

export const MsTeamsAuthSaml = () => {
  const { data: currentAccount } = useCurrentAccount();

  const [searchParams] = useSearchParams();
  const accountName = searchParams.get("account");
  const account = accountName || currentAccount.full_domain;
  const application = searchParams.get("application") || "tab";
  const oauthRedirectMethod = searchParams.get("oauthRedirectMethod");
  const authId = searchParams.get("authId");

  useEffect(() => {
    const samlParams = `msTeams=true&account=${account}&application=${application}&`;
    const appDeepLinkParams = `oauthRedirectMethod=${oauthRedirectMethod}&authId=${authId}`;

    const authorizeParams = new URLSearchParams({
      account,
      client_id: window.PF.config.client_id || "",
      grant_type: "saml",
      redirect_uri: UiRoute(`/?${samlParams}&${appDeepLinkParams}`)
    });

    window.location.href = ApiRoute(`/api/oauth/authorize?${authorizeParams.toString()}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};
